import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setPlayerCustomError } from 'store/actions';

// Import helpers
import { isHlsSupported } from 'helpers/player';

// Import components
import PlayerTvContent from '../player_content/PlayerTvContent';

// Import context
import { ShakaPlayerTVProvider } from 'components/context/player/player_tv';

const PlayerContext = ({
	isSidebarVisible,
	type,
	isFocus,
	error,
	resetFocus,
	playerParentElement,
	setPlayerCustomError,
	isLivePlayer
}) => {
	const isHls = isHlsSupported();

	return (
		<ShakaPlayerTVProvider
			isLivePlayer={isLivePlayer}
			isSidebarVisible={isSidebarVisible}
			type={type}
			isHls={isHls}
			isFocus={isFocus}
			resetFocus={resetFocus}
			playerParentElement={playerParentElement}
		>
			<PlayerTvContent
				error={error}
				setPlayerCustomError={setPlayerCustomError}
				type={type}
			/>
		</ShakaPlayerTVProvider>
	);
};

PlayerContext.propTypes = {
	error: PropTypes.shape({ isError: PropTypes.bool.isRequired }).isRequired,
	type: PropTypes.string.isRequired,
	isFocus: PropTypes.bool.isRequired,
	isSidebarVisible: PropTypes.bool.isRequired,
	resetFocus: PropTypes.func.isRequired,
	playerParentElement: PropTypes.any.isRequired,
	setPlayerCustomError: PropTypes.func.isRequired,
	isLivePlayer: PropTypes.bool.isRequired
};

const mapStateToProps = (state, { type }) => {
	const { error } = state[type];
	return {
		error
	};
};

export default connect(
	mapStateToProps,
	{ setPlayerCustomError }
)(PlayerContext);
